import { useCallback, useState } from 'react';
import { RevertCompanyClosureAPI } from '../../api/API';
import { useSubscription } from '../../contexts/SubscriptionContext';
import { closureErrorMessage } from './companyClosure';

const DEFAULT_ERROR = 'Não foi possível manter a conta. Tente novamente.';

/**
 * "Manter conta": desfaz o encerramento pedido pelo dono e recarrega a
 * assinatura (o ciclo some do contexto). Usado pelo card de status em Backup e
 * dados e pelo banner do app. Resolve { success, error }.
 */
export default function useCompanyClosureRevert() {
    const { refreshSubscription } = useSubscription();
    const [reverting, setReverting] = useState(false);

    const revert = useCallback(() => new Promise((resolve) => {
        setReverting(true);
        RevertCompanyClosureAPI(
            () => {
                setReverting(false);
                refreshSubscription(true);
                resolve({ success: true });
            },
            (response) => {
                setReverting(false);
                // 409: o ciclo pode ter mudado (ex.: período pago acabou); recarrega o estado.
                refreshSubscription(true);
                resolve({ success: false, error: closureErrorMessage(response, DEFAULT_ERROR) });
            }
        );
    }), [refreshSubscription]);

    return { reverting, revert };
}
